export default __webpack_public_path__ + "static/media/equals.90cb5e4b.svg";